
    var riot = require('riot')
    //src: starling/src/tags/menu/items/menu-item-edit-region-shape.html
riot.tag2('menu-item-edit-region-shape',
  '<svg class="floating-menu_icon"> <use xlink:href="#format-shapes-icon"></use> </svg> <span class="floating-menu_label">Shape</span> <svg class="floating-menu_caret"> <use xlink:href="#caret-right-icon"></use> </svg>',
  '',
  'class="floating-menu_item" onmouseenter="{openShapePicker}"', function(opts) {
'use strict';

var _this = this;

var _constants = require('lib/constants');

var _delayHandler = require('lib/delay-handler');

var _menuUi = require('lib/menu-ui');

var _opts = opts,
    canvas = _opts.canvas;

_menuUi.mui.registerMenuItem(this, 'editRegionShape');

this.openShapePicker = function () {
  return _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'regionshape',
    delay: _constants.MENU_OPEN_DELAY,
    callback: function callback() {
      _this.parent.hideSubMenus();
      canvas.regionShapeMenu.summon({ referenceTag: _this });
    }
  });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-item-edit-region-shape')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/items/menu-item-edit-region-shape.html
// module id = 708
// module chunks = 0